import React, { useEffect, useState } from "react";
import TotalEnergiesContext from "./TotalEnergiesContext";
import {
  FormattedOwnerData,
  OwnerData,
} from "../../models/ownerData/ownerData.model";
import {
  getCifCupsFromLocalStorage,
  getOwnerDataFromLocalStorage,
  getUserDataFromLocalStorage,
  setCifCupsToLocalStorage,
  setOwnerDataToLocalStorage,
  setUserDataToLocalStorage,
} from "../../services/localStorage/localStorage.service";
import { UserData } from "../../models/login/login.model";
import { formatOwnerData } from "../../../utils/ownerData/ownerData.util";
import { SnackbarData } from "../../models/snackbar/snackbar.model";
import { initialSnackbarData } from "../../../utils/components/snackbar/snackbar.util";
import { CifCupsState } from "../../models/cupsCifSelector/cupsCifSelector.model";
import { ManagementsDetailHeader } from "../../models/managements/managements.model";

interface TotalEnergiesContextProviderProps {
  children: JSX.Element;
}

const TotalEnergiesContextProvider = ({
  children,
}: TotalEnergiesContextProviderProps) => {
  const [ownerData, setOwnerData] = useState<FormattedOwnerData | null>(null);
  const [userData, setUserData] = useState<UserData | null>(null);
  const [snackbarData, setSnackbarData] =
    useState<SnackbarData>(initialSnackbarData);
  const [cifCupsState, setCifCupsState] = useState<CifCupsState>(
    getCifCupsFromLocalStorage()!
  );
  const [managementsDetailHeader, setManagementsDetailHeader] =
    useState<ManagementsDetailHeader>({
      recordTextType: "",
      claimTextSubType: "",
      incidenceText: "",
    });

  useEffect(() => {
    setOwnerData(getOwnerDataFromLocalStorage());
    setUserData(getUserDataFromLocalStorage());
    setCifCupsState(getCifCupsFromLocalStorage()!);
  }, []);

  const storageOwnerData = (ownerData: OwnerData) => {
    setOwnerDataToLocalStorage(ownerData);
    setOwnerData(formatOwnerData(ownerData));
  };

  const storageUserData = (userData: UserData) => {
    setUserDataToLocalStorage(userData);
    setUserData(userData);
  };

  const storageCifCupsState = (cifCups: CifCupsState) => {
    setCifCupsToLocalStorage(cifCups);
    setCifCupsState(cifCups);
  };

  useEffect(() => {
    setUserData({
      token: "",
      refreshToken: "",
      expiresIn: "",
      codeVerifier: "",
      clientType: 0,
      idToken: "",
      user: "",
    });
  }, []);

  return (
    <TotalEnergiesContext.Provider
      value={{
        ownerData,
        storageOwnerData,
        userData,
        setUserData,
        storageUserData,
        snackbarData,
        setSnackbarData,
        cifCupsState,
        storageCifCupsState,
        managementsDetailHeader,
        setManagementsDetailHeader,
      }}
    >
      {children}
    </TotalEnergiesContext.Provider>
  );
};

export default TotalEnergiesContextProvider;
